import { initialsOf } from '../../util/initials'

const Avatar = ({ name, size = 40 }: { name: string; size?: number }) => (
  <div
    className="rounded-full bg-green-100 text-green-800 flex items-center justify-center font-bold shrink-0"
    style={{
      width: size,
      height: size,
      fontSize: size <= 24 ? 10 : size <= 32 ? 12 : 14,
    }}
  >
    {initialsOf(name)}
  </div>
)

export default Avatar
